import { BaseApiService } from "../base/base-api.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PreferenceOption } from '../../../models/preference-option/preference-option.model';
import { PreferenceOptionSerializer } from '../../../models/preference-option/preference-option-serializer.class';
import { CustomErrorHandlerService } from '../custom-error-handler.service';

@Injectable()
export class PreferenceOptionService extends BaseApiService<PreferenceOption> {
  constructor(httpClient: HttpClient) {
    super(
        httpClient, 
        null, 
        "preferenceoptions", 
        new PreferenceOptionSerializer(), 
        new CustomErrorHandlerService());
  }
}
